;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { FormFeedback, Label } from 'reactstrap';
import PhoneInput from 'react-phone-number-input';
import usePhoneInputLabelLanguage from '../../../hooks/usePhoneInputLabelLanguage';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';

import 'react-phone-number-input/style.css';

interface FormikTelephoneInputProps {
  name: string;
  formik: any;
  intlKey?: string;
  id?: string;
  required?: boolean;
  className?: string;
  dictionary: Partial<Dictionaries>;
}

function FormikTelephoneInput(props: FormikTelephoneInputProps): JSX.Element {
  const phoneLabelLanguage = usePhoneInputLabelLanguage();
  const { className, dictionary, name, id, required, intlKey, formik } = props;
  const { formatMessage } = getI18nUtils(dictionary);
  const { touched, error } = formik.getFieldMeta(name);
  const invalid = touched && error;

  return (
    <div className={className || ''}>
      <Label for={name} className={required ? 'required' : ''}>
        {formatMessage({ id: intlKey || name })}
      </Label>

      <PhoneInput
        className={`form-control${invalid ? ' is-invalid' : ''}`}
        defaultCountry="BE"
        labels={phoneLabelLanguage}
        international
        countryCallingCodeEditable={false}
        name={name}
        id={id || name}
        onChange={(E164Number) => formik.setFieldValue(name, E164Number)}
        onBlur={(e) => formik.handleBlur(e)}
        value={formik.values[name]}
      />
      {error && <FormFeedback>{formatMessage({ id: error })}</FormFeedback>}
    </div>
  );
}

export default FormikTelephoneInput;
